'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/IconSvg/index.js');
var ReactDOM = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

var Tooltip = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Tooltip, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      showTooltip: false,
      slotPositionX: 0,
      slotPositionY: 0
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "showTooltip", function (ev) {
      var slot = ev.currentTarget;
      var slotPosition = slot.getBoundingClientRect();

      _this.setState({
        showTooltip: true,
        slotPositionX: slotPosition.x,
        slotPositionY: slotPosition.y
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "hideTooltip", function () {
      _this.setState({
        showTooltip: false
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Tooltip, [{
    key: "createTooltip",
    value: function createTooltip() {
      if (!this.props.show || !this.state.showTooltip) return null;
      var left = "".concat(window.scrollX + this.state.slotPositionX - this.props.positionX, "px");
      var top = "".concat(window.scrollY + this.state.slotPositionY + this.props.positionY, "px");
      return /*#__PURE__*/React__default['default'].createElement("span", {
        style: {
          left: left,
          top: top
        },
        className: "ds-tooltip ".concat(this.props.className, " ").concat(this.props.clear ? 'clear' : '')
      }, this.props.tooltipInfo);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-tooltip-container ".concat(this.props.className),
        onMouseOver: function onMouseOver(ev) {
          return _this2.showTooltip(ev);
        },
        onFocus: function onFocus(ev) {
          return _this2.showTooltip(ev);
        },
        onMouseLeave: function onMouseLeave(ev) {
          return _this2.hideTooltip(ev);
        },
        onBlur: function onBlur(ev) {
          return _this2.hideTooltip(ev);
        }
      }, this.props.children ? this.props.children : /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-tooltip-trigger-icon ".concat(this.props.className),
        icon: "info",
        localSource: this.props.localSource
      }), ReactDOM__default['default'].createPortal(this.createTooltip() || [], document.body));
    }
  }]);

  return Tooltip;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(Tooltip, "propTypes", {
  className: PropTypes__default['default'].string,
  clear: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node,
  localSource: PropTypes__default['default'].bool,
  positionX: PropTypes__default['default'].number,
  positionY: PropTypes__default['default'].number,
  show: PropTypes__default['default'].bool,
  tooltipInfo: PropTypes__default['default'].any.isRequired
});

_rollupPluginBabelHelpers.defineProperty(Tooltip, "defaultProps", {
  className: '',
  clear: false,
  children: null,
  localSource: false,
  positionX: 10,
  positionY: 25,
  show: true
});

module.exports = Tooltip;
